<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card my-4">
          <div class="card-header p-0 position-relative mt-n4 mx-3 z-index-2">
            <div
              class="bg-gradient-success shadow-success border-radius-lg pt-4 pb-3 d-flex justify-content-between align-items-center"
            >
              <h6 class="text-white text-capitalize ps-3">折價券管理</h6>
              <div class="pe-3">
                <router-link
                  to="/marketing/coupons/new"
                  class="btn btn-sm bg-gradient-light mb-0"
                >
                  <i class="material-icons text-sm">add</i> 新增折價券
                </router-link>
              </div>
            </div>
          </div>
          <div class="card-body px-0 pb-2">
            <div class="table-responsive p-0">
              <table class="table align-items-center mb-0">
                <thead>
                  <tr>
                    <th
                      class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                    >
                      代碼
                    </th>
                    <th
                      class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2"
                    >
                      類型 / 面額
                    </th>
                    <th
                      class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                    >
                      使用限制
                    </th>
                    <th
                      class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                    >
                      使用統計
                    </th>
                    <th
                      class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                    >
                      狀態
                    </th>
                    <th
                      class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                    >
                      有效期
                    </th>
                    <th class="text-secondary opacity-7"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="coupon in coupons" :key="coupon.id">
                    <td>
                      <div class="d-flex px-2 py-1">
                        <div class="d-flex flex-column justify-content-center">
                          <h6 class="mb-0 text-sm">{{ coupon.code }}</h6>
                          <p
                            class="text-xs text-secondary mb-0"
                            v-if="coupon.notes"
                          >
                            {{ coupon.notes }}
                          </p>
                        </div>
                      </div>
                    </td>
                    <td>
                      <p class="text-xs font-weight-bold mb-0">
                        {{ coupon.type === "fixed" ? "定額" : "百分比" }}
                      </p>
                      <p class="text-xs text-secondary mb-0">
                        {{
                          coupon.type === "fixed"
                            ? "$" + coupon.value
                            : coupon.value + "%"
                        }}
                      </p>
                    </td>
                    <td class="align-middle text-center text-sm">
                      <span class="text-secondary text-xs font-weight-bold">
                        {{
                          coupon.min_spend
                            ? "滿 $" + coupon.min_spend
                            : "無低消"
                        }}
                      </span>
                    </td>
                    <td class="align-middle text-center">
                      <span
                        class="text-secondary text-xs font-weight-bold d-block"
                      >
                        {{ coupon.real_usage_count || coupon.usage_count || 0 }}
                        次
                      </span>
                      <span class="text-xs text-success font-weight-bold">
                        省下 ${{ coupon.total_discount_amount || 0 }}
                      </span>
                    </td>
                    <td class="align-middle text-center text-sm">
                      <span
                        class="badge badge-sm"
                        :class="
                          coupon.is_active
                            ? 'bg-gradient-success'
                            : 'bg-gradient-secondary'
                        "
                      >
                        {{ coupon.is_active ? "啟用" : "停用" }}
                      </span>
                    </td>
                    <td class="align-middle text-center">
                      <span class="text-secondary text-xs font-weight-bold">
                        {{ formatDate(coupon.start_at) }} ~
                        {{ formatDate(coupon.end_at) }}
                      </span>
                    </td>
                    <td class="align-middle">
                      <router-link
                        :to="'/marketing/coupons/' + coupon.id"
                        class="text-info font-weight-bold text-xs me-3"
                        data-toggle="tooltip"
                        data-original-title="View details"
                      >
                        查看
                      </router-link>
                      <router-link
                        :to="'/marketing/coupons/' + coupon.id + '/edit'"
                        class="text-secondary font-weight-bold text-xs"
                        data-toggle="tooltip"
                        data-original-title="Edit user"
                      >
                        編輯
                      </router-link>
                      <a
                        href="javascript:;"
                        class="text-danger font-weight-bold text-xs ms-3"
                        @click="deleteCoupon(coupon.id)"
                      >
                        刪除
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="p-3 text-center" v-if="coupons.length === 0">
              無資料
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "@/utils/request"; // Assuming global axios config
import Swal from "sweetalert2";

export default {
  name: "Coupons",
  data() {
    return {
      coupons: [],
    };
  },
  mounted() {
    this.fetchCoupons();
  },
  methods: {
    async fetchCoupons() {
      try {
        const response = await axios.get("/api/admin/coupons");
        this.coupons = response.data;
      } catch (error) {
        console.error("Error fetching coupons:", error);
      }
    },
    async deleteCoupon(id) {
      const result = await Swal.fire({
        title: "確定要刪除嗎?",
        text: "刪除後無法復原",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "是的, 刪除!",
        cancelButtonText: "取消",
      });

      if (result.isConfirmed) {
        try {
          await axios.delete(`/api/admin/coupons/${id}`);
          this.coupons = this.coupons.filter((c) => c.id !== id);
          Swal.fire("已刪除!", "折價券已刪除.", "success");
        } catch (error) {
          console.error(error);
          Swal.fire("錯誤!", "刪除失敗.", "error");
        }
      }
    },
    formatDate(dateStr) {
      if (!dateStr) return "無期限";
      return new Date(dateStr).toLocaleDateString();
    },
  },
};
</script>
